import './ContactFilterOverview.scss';
import template from './ContactFilterOverview.vhtml';

export default {
	name: 'ContactFilterOverview',
	template: template,
	props: {
		endpoint: {
			type: String,
		},
		search: {
			type: String,
			default: '',
		},
		category: {
			type: [Number, String],
			default: '',
		},
	},
	methods: {
		noSpaces(string) {
			return string.split(' ').join('');
		},
	},
};
